import FormMain from './FormMain';
import FormActivities from './FormActivities';
import FormVehicles from './FormVehicles';
// import FormAffiliate from './FormAffiliate';
import FormComments from './FormComments';

const FormConfig = {
  steps: [
    { title: 'Description de la déclaration', component: FormMain },
    { title: 'Description des activités', component: FormActivities },
    { title: 'Stationnement & véhicule(s) autorisé(s)', component: FormVehicles },
    // { title: 'Affiliations', component: FormAffiliate },
    { title: 'Informations complémentaires', component: FormComments },
  ],
  title: {
    edit: 'Nouvelle demande d\'autorisation',
    preview: 'Récapitulatif de la demande d\'autorisation',
  },
  confirmation: {
    backButton: 'Retour',
    draftButton: 'Enregistrer un brouillon',
    previewButton: 'Voir le récapitulatif de ma déclaration',
    editButton: 'Modifier ma déclaration',
    printButton: 'Imprimer la déclaration',
    submitButton: 'Soumettre ma déclaration',
    modal: {
      action: 'Aller à mon interface de suivi',
      text: 'Votre déclaration a été envoyée pour approbation à l\'ONF. Suivez le statut de votre déclaration via votre interface de suivi.',
    },
  },
};

export default FormConfig;



// WEBPACK FOOTER //
// ./src/components/Form/Form.config.js